import React from 'react'
import PropTypes from 'prop-types'

import { useTheme } from 'styled-components'
import themeGet from '@styled-system/theme-get'

import { Dots, Heading } from 'Components/Blocks/_Legacy'
import { Border, Motion, Wrapper } from 'Components/UI'
import { Button, Icon, Text } from 'Components/UI/_Legacy'

import {
  boxGlyph,
  iconGrammerlyGlyph,
  lampGlyph,
  shuttleGlyph,
} from 'Assets/_Legacy/CtoPage'
import arrowRightShortGlyph from 'Assets/_Legacy/Svg/arrow-right-short.svg'

import { useAppContext } from 'Services/AppContext'

import {
  Card,
  CardContainer,
  Container,
  Content,
  DotsContainer,
} from './styles'

const CARD_ICONS = [shuttleGlyph, lampGlyph, boxGlyph]

function Caas({ data }) {
  const { openSupportWidget } = useAppContext()
  const theme = useTheme()

  return (
    <>
      <Border almond topRight />

      <Container>
        <Wrapper>
          <Content>
            <Motion>
              <Heading
                fontSizes={{ title: [24, 24, 45], sub: [14, 14, 16] }}
                horizontalAlign={['left', 'left', 'center']}
                tagGlyph={iconGrammerlyGlyph}
                tagText={data?.caasTagText}
                titleText={{
                  first: { text: data?.caasTitleRegular, bold: false },
                  second: { text: data?.caasTitleBold, bold: true },
                }}
              />
            </Motion>

            <Motion>
              <CardContainer mb={[9, 9, 9, 11]} mt={['96px', '96px', '140px']}>
                <DotsContainer>
                  <Dots
                    columns={11}
                    corners={[true, true, true, true]}
                    margin={6}
                    primary
                    rows={12}
                  />
                </DotsContainer>

                {data?.caasCard.map((card, index) => (
                  <Card key={card.id}>
                    <Icon glyph={CARD_ICONS[index]} />

                    <Text
                      as="h3"
                      bold
                      fontSize={[5, 5, 5, 6]}
                      mb={[3, 3, 3, 5]}
                    >
                      {card.cardTitle}
                    </Text>

                    <Text fontSize={[14, 14, 14, 14, 14, 16]} light>
                      {card.cardText}
                    </Text>
                  </Card>
                ))}
              </CardContainer>
            </Motion>

            <Motion>
              <Button blueprint width={250} onClick={openSupportWidget}>
                {data?.caasDiscussLinkText}
                &nbsp;
                <Icon glyph={arrowRightShortGlyph} size={10} />
              </Button>
            </Motion>
          </Content>
        </Wrapper>
      </Container>

      <Border almond bottomLeft />
      <Border bg={themeGet('colors.bg.almond')({ theme })} topRight />
    </>
  )
}

Caas.defaultProps = {
  data: {},
}

Caas.propTypes = {
  data: PropTypes.object,
}

export default Caas
